import { cx } from '@linaria/atomic';
import { AnimatePresence, motion, MotionProps } from 'motion/react';
import { ContentLoader } from '../../loader/content-loader';
import { useModalContext } from '../provider/modal.provider';
import { fullscreenModalContainer } from './fullscreen-modal.styles';

type Props = {
  children: React.ReactNode;
  style?: { [key: string]: any };
} & MotionProps;

export const FullScreenModalContainer = ({ children, style, className, ...rest }: Props & { className?: string }) => {
  const { containerProps, loadingState } = useModalContext();
  return (
    <AnimatePresence>
      <motion.section {...containerProps} {...rest} className={cx(fullscreenModalContainer, className)} style={style}>
        {children}
        <ContentLoader {...loadingState} />
      </motion.section>
    </AnimatePresence>
  );
};
